export class SWTemplateProvider {
    constructor() {
        this._template = null;
    }

    getTemplate(object, type) {
        if(this._template){
            const template = this._template(object, type);
            if (template) {
                return template;
            }
        }
    }

    setTemplate(callback) {
        this._template = callback;
    }
}